import React from 'react'
import PropTypes from 'prop-types'
import {Icon} from '@chakra-ui/react'

const TwintIcon = (props) => {
    return (
        <Icon viewBox="0 0 279 181" cursor="pointer" {...props}>
            <path
                fill="transparent"
                opacity="1.000000"
                stroke="none"
                d="
                M178.000000,182.000000
                C118.666672,182.000000 59.833347,182.000000 1.000016,182.000000
                C1.000010,121.666679 1.000010,61.333363 1.000005,1.000032
                C93.999977,1.000021 186.999954,1.000021 279.999939,1.000011
                C279.999969,61.333302 279.999969,121.666603 280.000000,181.999954
                C246.166672,182.000000 212.333328,182.000000 178.000000,182.000000
                M57.668385,121.835526
                C58.678276,122.409180 59.790115,122.856972 60.680447,123.578217
                C64.585922,126.742027 68.160370,126.368713 72.350456,123.647209
                C79.154312,119.228035 86.287598,115.299454 93.405815,111.389534
                C96.036140,109.944725 97.242310,108.288361 97.177605,105.172226
                C96.987625,96.022018 97.308334,86.857735 96.957428,77.717072
                C96.881042,75.727371 95.315094,73.062119 93.623184,71.992851
                C85.919510,67.124237 78.018196,62.540199 69.965454,58.273804
                C68.173157,57.324230 65.046837,57.248886 63.277374,58.180923
                C55.069283,62.504414 47.032150,67.179077 39.157993,72.087639
                C37.567158,73.079330 36.088402,75.599442 36.024853,77.464859
                C35.707703,86.774673 35.680405,96.108841 36.040134,105.415543
                C36.116314,107.386444 37.787510,109.962357 39.495632,111.081558
                C45.171986,114.800835 51.200043,117.983337 57.668385,121.835526
                M156.057190,102.660805
                C157.424271,99.137238 158.791336,95.613670 160.397903,91.472801
                C162.438980,96.878281 164.157913,101.651421 166.076721,106.342812
                C166.507294,107.395515 167.637115,108.162224 168.445023,109.060600
                C169.249283,108.197205 170.491211,107.462784 170.789566,106.450310
                C173.542419,97.107956 176.132187,87.717552 178.841202,78.085793
                C176.499313,78.085793 174.381500,78.085793 171.936783,78.085793
                C170.533508,83.320816 169.128464,88.562431 167.489456,94.676826
                C165.657867,89.428085 164.141769,84.911911 162.477310,80.451096
                C162.122833,79.501060 161.228500,78.752457 160.582870,77.911057
                C159.769501,78.785431 158.601578,79.523712 158.204620,80.557915
                C156.551971,84.863541 155.131485,89.258286 153.294571,94.580063
                C151.592438,88.316994 150.177032,83.108917 148.841232,78.193817
                C146.235916,78.193817 144.169968,78.193817 141.867126,78.193817
                C144.297409,86.660980 146.540985,94.791298 149.004913,102.854286
                C149.668961,105.027328 151.002060,106.995911 152.028061,109.058334
                C153.312866,107.178856 154.597687,105.299377 156.057190,102.660805
                M215.309372,108.037697
                C217.573639,108.498062 219.837891,108.958435 222.105118,109.419411
                C222.105118,101.047768 222.562378,93.402748 221.957901,85.842628
                C221.489120,79.979668 217.037003,76.980644 210.692139,76.829948
                C204.236542,76.676628 198.880936,79.770393 198.391586,85.345947
                C197.703674,93.183495 198.217697,101.126518 198.217697,108.909500
                C200.674408,108.909500 202.630508,108.909500 205.020798,108.909500
                C205.020798,102.628960 205.107773,96.506912 204.988998,90.388847
                C204.914780,86.566406 205.956619,83.521439 210.265808,83.547333
                C214.306335,83.571602 215.344894,86.487732 215.277313,90.116974
                C215.171906,95.778152 215.253113,101.442810 215.309372,108.037697
                M114.135239,83.721352
                C116.717216,83.721352 119.299194,83.721352 122.207779,83.721352
                C122.207779,92.510674 122.207779,100.588371 122.207779,108.789268
                C124.775253,108.789268 126.986481,108.789268 129.547516,108.789268
                C129.547516,100.441071 129.547516,92.369698 129.547516,84.076584
                C132.593643,83.913696 135.307465,83.768585 138.002960,83.624451
                C138.002960,81.480278 138.002960,79.740623 138.002960,78.019714
                C129.649689,78.019714 121.586540,78.019714 113.213654,78.019714
                C113.302582,79.918411 113.378906,81.547859 114.135239,83.721352
                M233.570282,77.767799
                C231.141312,77.767799 228.712357,77.767799 226.047592,77.767799
                C226.180069,80.214058 226.273300,81.935616 226.382233,83.947380
                C229.499664,83.947380 232.100266,83.947380 235.206665,83.947380
                C235.206665,92.481659 235.206665,100.707581 235.206665,108.804749
                C237.822754,108.804749 239.919617,108.804749 242.344635,108.804749
                 C242.344635,100.445030 242.344635,92.348404 242.344635,84.068115
                C245.416122,83.909019 248.166138,83.766579 251.144943,83.612289
                C251.039597,81.456650 250.954041,79.706085 250.859329,77.767799
                C245.168915,77.767799 239.859070,77.767799 233.570282,77.767799
                M187.484955,77.780846
                C186.327896,78.289139 184.172546,78.777100 184.161713,79.308746
                C183.960159,89.205551 184.013794,99.107552 184.013794,108.854584
                C186.666183,108.854584 188.614288,108.854584 190.956100,108.854584
                C190.956100,99.034058 191.007187,89.415100 190.848160,79.799622
                C190.836823,79.113991 189.284576,78.453842 187.484955,77.780846
                z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
                M57.380814,121.603592
                C51.200043,117.983337 45.171986,114.800835 39.495632,111.081558
                C37.787510,109.962357 36.116314,107.386444 36.040134,105.415543
                C35.680405,96.108841 35.707703,86.774673 36.024853,77.464859
                C36.088402,75.599442 37.567158,73.079330 39.157993,72.087639
                C47.032150,67.179077 55.069283,62.504414 63.277374,58.180923
                C65.046837,57.248886 68.173157,57.324230 69.965454,58.273804
                C78.018196,62.540199 85.919510,67.124237 93.623184,71.992851
                C95.315094,73.062119 96.881042,75.727371 96.957428,77.717072
                C97.308334,86.857735 96.987625,96.022018 97.177605,105.172226
                C97.242310,108.288361 96.036140,109.944725 93.405815,111.389534
                C86.287598,115.299454 79.154312,119.228035 72.350456,123.647209
                C68.160370,126.368713 64.585922,126.742027 60.680447,123.578217
                C59.790115,122.856972 58.678276,122.409180 57.380814,121.603592
                M59.875931,90.093094
                C59.875931,90.093094 59.724014,90.131531 59.859875,90.693512
                C60.149158,90.908997 60.438442,91.124474 60.695515,91.390953
                C60.695515,91.390953 60.668655,91.444962 60.770340,92.104561
                C62.154598,94.061943 63.538857,96.019325 65.198288,98.427933
                C65.370522,98.390907 65.542763,98.353889 65.677116,98.391747
                C65.677116,98.391747 65.683556,98.475418 65.644638,99.169685
                C67.430168,101.958511 68.962448,104.970543 71.126488,107.425743
                C71.986130,108.401047 75.265816,108.911377 75.708588,108.324432
                C79.552162,103.229477 83.000870,97.836647 86.782272,92.212318
                C77.911163,90.062630 78.101913,98.881424 73.368843,101.855705
                C72.273781,99.913521 71.170532,97.956841 70.626160,95.627388
                C71.707672,94.003677 72.818497,92.398590 73.864815,90.752510
                C76.314102,86.899277 76.528671,83.170547 72.871819,79.070786
                C65.862114,74.140739 59.440220,76.723312 57.959057,85.722183
                C58.301468,86.818329 58.643879,87.914467 59.038479,89.570061
                C59.315601,89.796600 59.592724,90.023140 59.875931,90.093094
                M53.818993,102.301643
                C53.818993,102.301643 53.797668,102.336372 53.978237,102.991882
                C55.163841,104.792435 56.126434,106.819466 57.628563,108.298569
                C58.386375,109.044777 60.496510,109.413528 61.350132,108.893723
                C65.001633,106.670113 65.451294,102.478790 62.578136,98.810013
                C61.625305,99.607201 60.678288,100.399529 59.505653,101.380615
                C58.656845,100.415367 57.900089,99.554810 56.970337,98.055000
                C55.237171,95.725578 53.504002,93.396164 51.559162,90.406540
                C49.324638,86.727257 46.530621,83.044342 53.567272,81.202278
                C54.628754,80.924408 55.201504,78.779572 56.176643,77.215546
                C51.338837,76.163818 47.701157,76.735733 45.315826,80.454826
                C42.877850,84.255997 43.504772,88.038170 46.095673,91.578568
                C46.964493,92.765785 47.878689,93.919800 49.026726,95.712204
                C50.330109,97.483192 51.633495,99.254181 53.037685,101.568008
                C53.303383,101.800217 53.569077,102.032417 53.818993,102.301643
                z"
            />
            <path
                fill="#F5F5F5"
                opacity="1.000000"
                stroke="none"
                d="
                M155.969849,103.040352
                C154.597687,105.299377 153.312866,107.178856 152.028046,109.058334
                C151.002060,106.995911 149.668961,105.027328 149.004913,102.854286
                C146.540985,94.791298 144.297409,86.660980 141.867126,78.193817
                C144.169968,78.193817 146.235916,78.193817 148.841232,78.193817
                C150.177032,83.108917 151.592438,88.316994 153.294571,94.580063
                C155.131485,89.258286 156.551971,84.863541 158.204620,80.557
                C158.204620,80.557915
                C158.601578,79.523712 159.769501,78.785431 160.582870,77.911057
                C161.228500,78.752457 162.122833,79.501060 162.477310,80.451096
                C164.141769,84.911911 165.657867,89.428085 167.489456,94.676826
                C169.128464,88.562431 170.533508,83.320816 171.936783,78.085793
                C174.381500,78.085793 176.499313,78.085793 178.841202,78.085793
                C176.132187,87.717552 173.542419,97.107956 170.789566,106.450310
                C170.491211,107.462784 169.249283,108.197205 168.445023,109.060600
                C167.637115,108.162224 166.507294,107.395515 166.076721,106.342812
                C164.157913,101.651421 162.438980,96.878281 160.397903,91.472801
                C158.791336,95.613670 157.424271,99.137238 155.969849,103.040352
                z"
            />
            <path
                fill="#F4F4F4"
                opacity="1.000000"
                stroke="none"
                d="
                M215.282303,107.571838
                C215.253113,101.442810 215.171906,95.778152 215.277313,90.116974
                C215.344894,86.487732 214.306335,83.571602 210.265808,83.547333
                C205.956619,83.521439 204.914780,86.566406 204.988998,90.388847
                C205.107773,96.506912 205.020798,102.628960 205.020798,108.909500
                C202.630508,108.909500 200.674408,108.909500 198.217697,108.909500
                C198.217697,101.126518 197.703674,93.183495 198.391586,85.345947
                C198.880936,79.770393 204.236542,76.676628 210.692139,76.829948
                C217.037003,76.980644 221.489120,79.979668 221.957901,85.842628
                C222.562378,93.402748 222.105118,101.047768 222.105118,109.419411
                C219.837891,108.958435 217.573639,108.498062 215.282303,107.571838
                z"
            />
            <path
                fill="#F6F6F6"
                opacity="1.000000"
                stroke="none"
                d="
                M113.795227,83.449326
                C113.378906,81.547859 113.302582,79.918411 113.213654,78.019714
                C121.586540,78.019714 129.649689,78.019714 138.002960,78.019714
                C138.002960,79.740623 138.002960,81.480278 138.002960,83.624451
                C135.307465,83.768585 132.593643,83.913696 129.547516,84.076584
                C129.547516,92.369698 129.547516,100.441071 129.547516,108.789268
                C126.986481,108.789268 124.775253,108.789268 122.207779,108.789268
                C122.207779,100.588371 122.207779,92.510674 122.207779,83.721352
                C119.299194,83.721352 116.717216,83.721352 113.795227,83.449326
                z"
            />
            <path
                fill="#F7F7F7"
                opacity="1.000000"
                stroke="none"
                d="
                M234.059753,77.767799
                C239.859070,77.767799 245.168915,77.767799 250.859329,77.767799
                C250.954041,79.706085 251.039597,81.456650 251.144943,83.612289
                C248.166138,83.766579 245.416122,83.909019 242.344635,84.068115
                C242.344635,92.348404 242.344635,100.445030 242.344635,108.804749
                C239.919617,108.804749 237.822754,108.804749 235.206665,108.804749
                C235.206665,100.707581 235.206665,92.481659 235.206665,83.947380
                C232.100266,83.947380 229.499664,83.947380 226.382233,83.947380
                C226.273300,81.935616 226.180069,80.214058 226.047592,77.767799
                C228.712357,77.767799 231.141312,77.767799 234.059753,77.767799
                z"
            />
            <path
                fill="#FCFCFC"
                opacity="1.000000"
                stroke="none"
                d="
                M187.966888,77.781342
                C189.284576,78.453842 190.836823,79.113991 190.848160,79.799622
                C191.007187,89.415100 190.956100,99.034058 190.956100,108.854584
                C188.614288,108.854584 186.666183,108.854584 184.013794,108.854584
                C184.013794,99.107552 183.960159,89.205551 184.161713,79.308746
                C184.172546,78.777100 186.327896,78.289139 187.966888,77.781342
                z"
            />
            <path
                fill="#FF0F0C"
                opacity="1.000000"
                stroke="none"
                d="
                M70.067291,96.000153
                C71.170532,97.956841 72.273781,99.913521 73.368843,101.855705
                C78.101913,98.881424 77.911163,90.062630 86.782272,92.212318
                C83.000870,97.836647 79.552162,103.229477 75.708588,108.324432
                C75.265816,108.911377 71.986130,108.401047 71.126488,107.425743
                C68.962448,104.970543 67.430168,101.958511 65.996277,98.662918
                C67.587715,97.437477 68.827499,96.718819 70.067291,96.000153
                z"
            />
            <path
                fill="#09B1E4"
                opacity="1.000000"
                stroke="none"
                d="
                M48.772141,95.088997
                C47.878689,93.919800 46.964493,92.765785 46.095673,91.578568
                C43.504772,88.038170 42.877850,84.255997 45.315826,80.454826
                C47.701157,76.735733 51.338837,76.163818 56.176643,77.215546
                C55.201504,78.779572 54.628754,80.924408 53.567272,81.202278
                C46.530621,83.044342 49.324638,86.727257 51.438698,90
                .997429
                C50.469536,92.755211 49.620838,93.922104 48.772141,95.088997
                z"
            />
            <path
                fill="#FF8009"
                opacity="1.000000"
                stroke="none"
                d="
                M70.346725,95.813766
                C68.827499,96.718819 67.587715,97.437477 66.015739,98.315781
                C65.683556,98.475418 65.677116,98.391747 65.754364,98.136665
                C65.528770,97.913292 65.225945,97.945000 64.923111,97.976715
                C63.538857,96.019325 62.154598,94.061943 61.109688,91.658035
                C62.644524,90.783188 63.840015,90.354874 65.268707,90.086906
                C69.196236,92.263756 68.254181,87.667694 70.402756,86.844795
                C71.526871,84.334091 72.336708,82.009979 73.146553,79.685867
                C76.528671,83.170547 76.314102,86.899277 73.864815,90.752510
                C72.818497,92.398590 71.707672,94.003677 70.346725,95.813766
                z"
            />
            <path
                fill="#FFC10B"
                opacity="1.000000"
                stroke="none"
                d="
                M73.009186,79.378326
                C72.336708,82.009979 71.526871,84.334091 70.410645,86.425667
                C69.058632,84.692932 68.013008,83.192726 66.967377,81.692528
                C65.616913,83.134659 64.266457,84.576782 62.555878,86.013855
                C60.830730,85.676216 59.465691,85.343628 58.100651,85.011040
                C59.440220,76.723312 65.862114,74.140739 73.009186,79.378326
                z"
            />
            <path
                fill="#0C7FBF"
                opacity="1.000000"
                stroke="none"
                d="
                M57.143330,98.694260
                C57.900089,99.554810 58.656845,100.415367 59.505653,101.380615
                C60.678288,100.399529 61.625305,99.607201 62.578136,98.810013
                C65.451294,102.478790 65.001633,106.670113 61.350132,108.893723
                C60.496510,109.413528 58.386375,109.044777 57.628563,108.298569
                C56.126434,106.819466 55.163841,104.792435 54.253868,102.538467
                C55.400772,100.954796 56.272049,99.824524 57.143330,98.694260
                z"
            />
            <path
                fill="#049FD7"
                opacity="1.000000"
                stroke="none"
                d="
                M57.056831,98.374634
                C56.272049,99.824524 55.400772,100.954796 54.163582,102.210716
                C53.797668,102.336372 53.818993,102.301643 53.775909,102.014145
                C53.467510,101.492813 53.202194,101.258995 52.936882,101.025169
                C51.633495,99.254181 50.330109,97.483192 48.899433,95.400604
                C49.620838,93.922104 50.469536,92.755211 51.544533,91.327530
                C53.504002,93.396164 55.237171,95.725578 57.056831,98.374634
                z"
            />
            <path
                fill="#FFA808"
                opacity="1.000000"
                stroke="none"
                d="
                M58.029854,85.366608
                C59.465691,85.343628 60.830730,85.676216 62.723831,86.285736
                C63.846436,87.683975 64.440971,88.805267 65.035507,89.926559
                C63.840015,90.354874 62.644524,90.783188 61.058846,91.328232
                C60.668655,91.444962 60.695515,91.390953 60.689217,91.067810
                C60.363285,90.540291 60.043648,90.335915 59.724014,90.131531
                C59.724014,90.131531 59.875931,90.093094 59.815056,89.907845
                C59.498215,89.485268 59.242252,89.247940 58.986290,89.010612
                C58.643879,87.914467 58.301468,86.818329 58.029854,85.366608
                z"
            />
            <path
                fill="#FF8009"
                opacity="1.000000"
                stroke="none"
                d="
                M59.791946,90.412521
                C60.043648,90.335915 60.363285,90.540291 60.705322,91.042313
                C60.438442,91.124474 60.149158,90.908997 59.791946,90.412521
                z"
            />
            <path
                fill="#FF8009"
                opacity="1.000000"
                stroke="none"
                d="
                M59.012386,89.290337
                C59.242252,89.247940 59.498215,89.485268 59.812012,89.986137
                C59.592724,90.023140 59.315601,89.796600 59.012386,89.290337
                z"
            />
            <path
                fill="#FF0F0C"
                opacity="1.000000"
                stroke="none"
                d="
                M65.060699,98.202324
                C65.225945,97.945000 65.528770,97.913292 65.773300,98.099228
                C65.542763,98.353889 65.370522,98.390907 65.060699,98.202324
                z"
            />
            <path
                fill="#0C7FBF"
                opacity="1.000000"
                stroke="none"
                d="
                M52.987282,101.296585
                C53.202194,101.258995 53.467510,101.492813 53.783798,101.995628
                C53.569077,102.032417 53.303383,101.800217 52.987282,101.296585
                z"
            />
            <path
                fill="#FFF9F0"
                opacity="1.000000"
                stroke="none"
                d="
                M65.268707,90.086914
                C64.440971,88.805267 63.846436,87.683975 63.083942,86.290787
                C64.266457,84.576782 65.616913,83.134659 66.967377,81.692528
                C68.013008,83.192726 69.058632,84.692932 70.096375,86.612259
                C68.254181,87.667694 69.196236,92.263756 65.268707,90.086914
                z"
            />
        </Icon>
    )
}

TwintIcon.propTypes = {
    onClick: PropTypes.func,
}

export default TwintIcon
